var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"placeholder"}),(_vm.$store.state.encodeInfo.zhangtao === '车质汇')?_c('span',{staticClass:"text"},[_vm._v("深圳市车质汇汽车配件有限公司")]):(_vm.$store.state.encodeInfo.zhangtao === '硬速')?_c('span',{staticClass:"text"},[_vm._v("硬速科技（深圳）有限公司")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }